import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getScholarLevelsRequest } from "lib/api/reference/scholarLevel";
import type { ScholarLevelInterface } from "types/reference";

export const scholarLevelReferenceKeys = {
    all: ["reference", "scholar-level"] as const,
    list: (languageCode: string) => [...scholarLevelReferenceKeys.all, "list", languageCode] as const,
};

export const fetchScholarLevels = (languageCode: string) =>
    parseResponse<Array<ScholarLevelInterface>>(getScholarLevelsRequest(languageCode));

export const scholarLevelReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<ScholarLevelInterface>>({
        queryKey: scholarLevelReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchScholarLevels(languageCode),
        enabled: Boolean(languageCode),
    });

export const useScholarLevels = (languageCode: string) => useQuery(scholarLevelReferenceQueryOptions(languageCode));
